import React from 'react'

function Icon({ fill = '#D16643' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="86"
      height="86"
      viewBox="0 0 86 86"
      fill="none"
    >
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.52"
        d="M84.16 43.08A41.08 41.08 0 1143.09 2a41.07 41.07 0 0141.07 41.08v0zM37.24 27.06c-7.17 2.12-13 6.48-13 16.6"
      ></path>
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.52"
        d="M52.98 16.68s-6.3 3.6-6.3 10.79a19.62 19.62 0 015.4-.9c8.09 0 17.08 5.28 17.08 17.09 0 11.66-7.09 21.58-15.28 21.58a21.247 21.247 0 01-3.6-.28"
      ></path>
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.52"
        d="M33.2 13.09s0 6.29 3.59 9.89a15.25 15.25 0 009.89 4.49s-.89-7.19-3.59-9.89a15.25 15.25 0 00-9.89-4.49zm29.64 27.87a12.48 12.48 0 00-4.92-7.28M41.04 47.26a1.81 1.81 0 01-1.55.9 1.85 1.85 0 01-1-.31 1.79 1.79 0 01-1.74 1.21 1.81 1.81 0 01-1.69-1.21 1.778 1.778 0 01-2.55-.59h-15.5c0 9.93 8.86 18 19.78 18 10.92 0 19.79-8 19.79-18H41.04z"
      ></path>
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.52"
        d="M37.69 54.45a5.912 5.912 0 00-.9-1.8 5.912 5.912 0 00-.9 1.8.9.9 0 101.8 0v0zm-6.03-.79c.32-.6.537-1.248.64-1.92a5.999 5.999 0 00-1.91.64.9.9 0 001.27 1.27v.01zm11.54-1.27a6 6 0 00-1.91-.65c.1.67.316 1.316.64 1.91a.9.9 0 001.27-1.27v.01z"
      ></path>
    </svg>
  )
}

export default Icon
